module.exports = __webpack_public_path__ + "static/media/bg_back_page_3.987852b1.jpg";